<template>
  <main class="success">
    <section v-if="loading" class="section">
      <div class="row align-center">
        <h1 class="success-title">
          Criando Pix...
        </h1>
      </div>
      <div class="row align-center">
        <font-awesome-icon class="success-icon" :icon="'spinner'" spin />
      </div>
    </section>

    <div v-else class="success success-content">
      <div v-if="pix">
        <div class="qr-code">
          <img :src="pix.qrCode" alt="Pix" />
        </div>

        <h1 class="success-title">Seu Pix foi emitido com sucesso!</h1>

        <p class="success-text">Clique no botão abaixo para copiar seu código Pix:</p>

        <button type="button" class="button" @click="copyToClipboard(pix.QrCodeText)">
          Copiar código Pix
        </button>
      </div>

      <ButtonStores />
    </div>
  </main>
</template>

<script>
import ButtonStores from '@/components/buttons/ButtonStores.vue';
import Register from '@/services/register';
import Payment from '@/services/payment';
import { copyTextToClipboard } from '@/utils/clipboard';

const register = new Register();
const payment = new Payment();

export default {
  name: 'PaymentPix',
  components: {
    ButtonStores
  },
  data() {
    return {
      loading: true,
      programId: this.$route.params.programId,
      items: JSON.parse(sessionStorage.getItem('register')),
      data: null,
      clientId: sessionStorage.getItem('clientId'),
      pix: null
    };
  },
  mounted() {
    if (this.clientId) {
      this.programPayment();
    } else {
      this.programRegister();
    }
  },
  methods: {
    concatJson(obj1, obj2) {
      const obj = obj1;
      Object.keys(obj2).forEach(key => {
        obj[key] = obj2[key];
      });

      return obj;
    },
    programRegister() {
      if (!this.items) {
        return;
      }

      this.data = this.concatJson(this.items, {
        id: this.clientId,
        einstein: sessionStorage.einstein || 0,
        telemedicina_sharecare_individual: sessionStorage.telemedicina_sharecare_individual || 0,
        telemedicina_sharecare_familiar: sessionStorage.telemedicina_sharecare_familiar || 0,
        omt_sharecare: sessionStorage.omt_sharecare || 0
      });

      register
        .doRegister(this.programId, this.data)
        .then(res => {
          sessionStorage.setItem('clientId', res.data.data.id);
          this.clientId = sessionStorage.getItem('clientId');
          this.programPayment();
        })
        .catch(err => {
          this.$toaster.error(err.response.data.error.message);
          this.$router.push({
            name: 'register'
          });
        });
    },
    programPayment() {
      this.loading = true;

      this.data = this.concatJson(this.items, {
        id: this.clientId,
        type: 'pix',
        einstein: sessionStorage.einstein || 0,
        telemedicina_sharecare_individual: sessionStorage.telemedicina_sharecare_individual || 0,
        telemedicina_sharecare_familiar: sessionStorage.telemedicina_sharecare_familiar || 0,
        omt_sharecare: sessionStorage.omt_sharecare || 0,
        renewal: sessionStorage.renewal === '1'
      });

      if (sessionStorage.utm_source) {
        this.data.utm_source = sessionStorage.utm_source;
      }

      if (sessionStorage.xtra) {
        this.data.xtra = sessionStorage.xtra;
      }

      payment
        .doPayment(this.programId, this.data)
        .then(res => {
          const { pix_qrcode: qrCode, pix_qrcode_text: QrCodeText } = res?.data?.data || {};

          sessionStorage.clear();

          this.pix = { qrCode, QrCodeText };
        })
        .catch(err => {
          this.$toaster.error(err.response.data.error.message);
          this.$router.back();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    copyToClipboard(text) {
      copyTextToClipboard(text, this.$toaster);
    }
  }
};
</script>

<style scoped>
.qr-code img {
  max-width: 80%;
}

button.button {
  width: 100%;
}
</style>
